import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { Button } from '@mui/material'
import {
  BOOKED_EVENT_MODES,
  BOOKING_SESSION_STATUS_MAP,
  EVENT_TYPES_ARRAY,
} from 'src/consumer/constants'
dayjs.extend(utc)

export default function DetailComponent({
  bookedEventInfo,
  clinicBrand,
  onRescheduleClick,
  hideButtons = false,
  hideSessionStatus = false,
}) {
  const currentEventType = EVENT_TYPES_ARRAY?.find((event) => {
    return event?.id === bookedEventInfo?.eventType
  })
  const currentMode = BOOKED_EVENT_MODES?.[bookedEventInfo?.meetingSrc]

  return (
    <div className="w-100 h-100">
      <div className="d-flex flex-column gap-1">
        <span>
          {currentMode?.altTitle} {currentEventType?.title} with {bookedEventInfo?.mentorName}
        </span>
        <span>
          <strong>Ref:</strong> {clinicBrand?.title || clinicBrand?.brandName}
        </span>
      </div>

      {!hideSessionStatus && (
        <div>
          <strong>Session Status:</strong>{' '}
          {BOOKING_SESSION_STATUS_MAP?.[bookedEventInfo?.sessionStatus]?.title}
        </div>
      )}
      {!hideButtons && (
        <div className="d-flex align-items-center justify-content-center gap-2">
          {bookedEventInfo?.status === 'booked' && (
            <Button
              sx={{ width: 'fit-content', marginTop: '32px' }}
              variant="contained"
              onClick={onRescheduleClick}
            >
              Reschedule
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
